import React from 'react';
import { MAX_RATING, MAX_CHARS } from './utils/constants';
import { sanitizeInput, trimEmptySpaces } from './utils/validators';

function SurveyQuestion({ question, value, onChange, theme }) {
  const answerStyle = {
    fontFamily: theme.answer.fontFamily,
    fontSize: theme.answer.fontSize,
    color: theme.answer.color,
  };

  const handleTextChange = (e) => {
    let text = e.target.value;
    
    // Prevent typing over the limit
    if (text.length > MAX_CHARS) {
      text = text.substring(0, MAX_CHARS);
    }

    // Sanitize input: remove basic HTML tags
    text = sanitizeInput(text);

    // Trim string if it consists only of spaces
    text = trimEmptySpaces(text);

    onChange(text);
  };

  // Supported Types: 'text' (verbatim), 'rating'
  switch (question.type) {
    case 'text': {
      const currentLength = (value || '').length;
      return (
        <div>
          <textarea
            className="input-field textarea"
            placeholder={question.placeholder || 'Type your response here...'}
            value={value || ''}
            onChange={handleTextChange}
            rows={4}
            style={answerStyle}
          />
          <div className="char-counter" style={{ fontSize: '12px', color: '#666', marginTop: '4px', textAlign: 'right' }}>
            {currentLength} / {MAX_CHARS}
          </div>
        </div>
      );
    }

    case 'rating': {
      const maxScale = question.max || MAX_RATING;
      return (
        <div className="rating-group">
          {Array.from({ length: maxScale }, (_, i) => i + 1).map((star) => (
            <button
              key={star}
              type="button"
              className={`star-btn ${value >= star ? 'active' : ''}`}
              onClick={() => onChange(star)}
            >
              ★
            </button>
          ))}
          {value && <span className="rating-label">{value} / {maxScale}</span>}
        </div>
      );
    }

    default:
      // Unknown Type Fallback: Standard text input gracefully
      return (
        <input
          type="text"
          className="input-field"
          placeholder="Enter value"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          style={answerStyle}
        />
      );
  }
}

export default SurveyQuestion;
